import ko from 'knockout';
import _ from 'lodash';
import $ from 'jquery';

export default class consoleinLineStyleObj {

    constructor(data) {

        //this.log("topic Obj Model");
        //this.log(data);
        this.componentname = "styleObj";

        //New Data:
        this.id = data.id;
        this.subid = data.subid;
        this.partnerid = data.partnerid;
        this.styleCode = ko.observable(data.stylecode);
        this.styleType = data.styletype;
        this.createdate = data.createdate;

        this.inLineStyle = ko.computed(function() {

            //console.log("split Array - styleCode:");
            //console.log(typeof this.styleCode());

            if(this.styleCode()) {
                var styleArray = this.styleCode().split("{");

                if(styleArray[1] !== undefined)
                {
                    //Remove whitespace 
                    let inLineStyle =  _.trim(styleArray[1].replace("}","")).replace('/[^\x20-\x7E]+/g', '').replace(/(\r\n|\n|\r|\t)/g,"");
                    //this.log("style: " + inLineStyle);
                    //console.log("return inLineStyle...");
                    return inLineStyle;
                }

            }
            
            
            return "";
        

        }, this);

        this.styleName = ko.computed(function() {
            
            if(this.styleCode())
            {
                var styleArray = this.styleCode().split("{");
                if(styleArray[1] !== undefined)
                {
                    //Remove whitespace 
                    let inLineStyle =  _.trim(styleArray[0].replace("}","")).replace('/[^\x20-\x7E]+/g', '').replace(/(\r\n|\n|\r|\t)/g,"");
                    //this.log("styleName: " + inLineStyle);
    
                    return inLineStyle;
                }
            }
            
            return "";

        }, this);

        //this.log(this);


    }


}



// WEBPACK FOOTER //
// ./src/objects/inLineStyleObj.js